import { PromotionSkipCount } from '../../graphql/promotions'

/**
 * A skip whose promotion this operator has no standing to see.
 *
 * The service blanks the identity rather than dropping the row — dropping it would make this
 * screen's totals differ from the by-reason ones by exactly the number withheld. Both the
 * table and the chart must therefore agree on what counts as withheld, and on what to call it.
 *
 * IN ITS OWN MODULE, not in the table component. It started there, exported to the mobile twin
 * so that the classification was imported rather than re-derived — right rule, wrong home. Once
 * `skipChartSeries.ts` became a second consumer, a module with no React in it was transitively
 * importing `@material-ui/core` and an icon set, and an edit to the table's imports could break
 * the chart series' build. Deciding what a row IS belongs beside neither renderer.
 */
export const isUnattributedSkip = (row: PromotionSkipCount) =>
  row.promotionId === ''

export const UNATTRIBUTED_LABEL =
  'Another provider’s promotion — not visible to you'
